import { useState } from 'react';
import { emailSchema } from '@colette/shared';
import { C, DEGRADE_ACTION } from '../../theme';
import { styleChamp } from './champs';
import { api } from '../../api/routes';
import { ErreurApi } from '../../api/client';
import { messageDErreur } from '../../api/useDonnees';
import { LienTexte } from './CadreAuth';

/**
 * « Mot de passe oublié ? » (2026-08-28).
 *
 * L'ecran ne DIT JAMAIS si l'adresse existe : il repond la meme chose dans tous les cas,
 * exactement comme le serveur. Faire autrement en ferait un annuaire — il suffirait
 * d'essayer des adresses pour savoir qui a un compte chez Colette.
 *
 * Seule exception : quand l'envoi d'emails n'est pas configure du tout. La le taire
 * laisserait quelqu'un attendre un message qui ne partira jamais.
 */
export function MotDePasseOublie() {
  const [ouvert, setOuvert] = useState(false);
  const [email, setEmail] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [demande, setDemande] = useState(false);
  const [indisponible, setIndisponible] = useState<string | null>(null);

  const valide = emailSchema.safeParse(email).success;

  const demander = async () => {
    if (!valide || envoi) return;
    setEnvoi(true);
    setIndisponible(null);
    try {
      await api.demanderReinitialisation(email);
      setDemande(true);
    } catch (cause) {
      if (cause instanceof ErreurApi && cause.code === 'COURRIEL_NON_CONFIGURE') {
        setIndisponible(cause.message);
      } else {
        // Toute autre panne se tait de la meme facon qu'un succes : l'ecran ne doit rien
        // laisser deviner de l'existence du compte.
        setDemande(true);
        void messageDErreur(cause);
      }
    } finally {
      setEnvoi(false);
    }
  };

  if (demande) {
    return (
      <div style={{ fontSize: 13.5, color: C.secondaire, lineHeight: 1.55, textAlign: 'center' }}>
        Si un compte existe avec cette adresse, Colette vient d’y envoyer un lien. Il ne
        vaut qu’une heure.
      </div>
    );
  }

  if (!ouvert) {
    return (
      <div style={{ textAlign: 'center', fontSize: 13.5, color: C.secondaire }}>
        <LienTexte onClick={() => setOuvert(true)}>Mot de passe oublié ?</LienTexte>
      </div>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        void demander();
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
    >
      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span style={{ fontSize: 11.5, fontWeight: 800, letterSpacing: 0.6, color: C.tertiaire }}>
          TON ADRESSE EMAIL
        </span>
        <input
          type="email"
          inputMode="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-label="Ton adresse email"
          autoComplete="username"
          autoFocus
          style={styleChamp}
        />
      </label>
      {indisponible !== null ? (
        <div
          role="alert"
          style={{
            background: C.corailFond,
            border: `1px solid ${C.corailBordure}`,
            color: C.corailTexte,
            borderRadius: 12,
            padding: '10px 12px',
            fontSize: 12.5,
            fontWeight: 700,
            lineHeight: 1.45,
          }}
        >
          {indisponible}
        </div>
      ) : null}
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="submit"
          className="pressable"
          disabled={!valide || envoi}
          style={{
            flex: 1,
            height: 44,
            border: 'none',
            borderRadius: 12,
            background: valide && !envoi ? DEGRADE_ACTION : C.inactif,
            color: '#FFFFFF',
            fontSize: 14,
            fontWeight: 800,
            fontFamily: 'inherit',
            cursor: valide && !envoi ? 'pointer' : 'default',
          }}
        >
          {envoi ? '…' : 'Envoyer le lien'}
        </button>
        <button
          type="button"
          className="pressable"
          onClick={() => setOuvert(false)}
          style={{
            height: 44,
            padding: '0 14px',
            border: `1px solid ${C.bordure}`,
            borderRadius: 12,
            background: C.carte,
            color: C.secondaire,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
          }}
        >
          Annuler
        </button>
      </div>
    </form>
  );
}
